import _classCallCheck from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { EventEmitter } from "events";
import { CodedError } from "./CodedError";

var StorageHandler = /*#__PURE__*/function (_EventEmitter) {
  _inherits(StorageHandler, _EventEmitter);

  var _super = _createSuper(StorageHandler);

  function StorageHandler(namespace, version, options) {
    var _this;

    _classCallCheck(this, StorageHandler);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "namespace", void 0);

    _defineProperty(_assertThisInitialized(_this), "version", void 0);

    _defineProperty(_assertThisInitialized(_this), "cacheValidated", false);

    _defineProperty(_assertThisInitialized(_this), "handlers", void 0);

    _defineProperty(_assertThisInitialized(_this), "invalidatedCb", void 0);

    var _options$invalidated = options.invalidated,
        invalidated = _options$invalidated === void 0 ? function () {
      return null;
    } : _options$invalidated,
        _options$validateOnIn = options.validateOnInit,
        validateOnInit = _options$validateOnIn === void 0 ? true : _options$validateOnIn;
    _this.namespace = namespace;
    _this.version = version;
    _this.handlers = {};
    _this.invalidatedCb = invalidated;
    _this.getCacheKey = _this.getCacheKey.bind(_assertThisInitialized(_this));
    _this.getCacheVersionKey = _this.getCacheVersionKey.bind(_assertThisInitialized(_this));
    _this.invalidateCache = _this.invalidateCache.bind(_assertThisInitialized(_this));
    _this.checkCache = _this.checkCache.bind(_assertThisInitialized(_this));
    _this.getKeyHandler = _this.getKeyHandler.bind(_assertThisInitialized(_this));
    if (validateOnInit) _this.checkCache();
    return _this;
  }

  _createClass(StorageHandler, [{
    key: "getCacheKey",
    value: function getCacheKey() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return [this.namespace, key].filter(Boolean).join("_");
    }
  }, {
    key: "getCacheVersionKey",
    value: function getCacheVersionKey() {
      return this.getCacheKey("version");
    }
  }, {
    key: "invalidateCache",
    value: function invalidateCache() {
      if (typeof localStorage === "undefined") return;
      var keyPrefix = this.getCacheKey();
      var invalidated = false;

      for (var _i = 0, _Object$keys = Object.keys(localStorage); _i < _Object$keys.length; _i++) {
        var cacheKey = _Object$keys[_i];

        if (cacheKey.includes(keyPrefix)) {
          localStorage.removeItem(cacheKey);
          invalidated = true;
        }
      }

      localStorage.setItem(this.getCacheVersionKey(), this.version);

      if (invalidated) {
        this.handlers = {};
        this.emit("invalidated");
        this.invalidatedCb();
      }
    }
  }, {
    key: "checkCache",
    value: function checkCache() {
      if (this.cacheValidated || typeof localStorage === "undefined") return;
      var cacheVersion = localStorage.getItem(this.getCacheVersionKey());

      if (!cacheVersion || cacheVersion !== this.version) {
        console.warn("cached version not found OR version mismatch...");
        this.invalidateCache();
        console.log("cache invalidated... ");
      }

      this.cacheValidated = true;
    }
  }, {
    key: "getKeyHandler",
    value: function getKeyHandler(key, defaultValue, validate) {
      var _this2 = this;

      key = this.getCacheKey(key);
      if (this.handlers[key]) return this.handlers[key];

      var getStateValue = function getStateValue(val) {
        if (typeof defaultValue === "function") {
          return defaultValue(val);
        }

        return val || defaultValue;
      };

      var valType = typeof getStateValue();
      var handlerInitialization = true;
      var handler = {
        get: function get() {
          if (typeof localStorage === "undefined") return getStateValue();
          var ret = getStateValue();

          try {
            var item = localStorage.getItem(key);
            if (item) ret = getStateValue(JSON.parse(item));

            if (validate && typeof validate === "function") {
              var isValid = validate(ret);

              if (!isValid) {
                console.warn(["cache value for ".concat(key, " is invalid"), "resetting it to default"].join("\n"));
                ret = getStateValue();
              }
            }

            valType = typeof ret;
          } catch (e) {
            console.error(e.message + "");
            console.warn(["Failed to parse cached value for ".concat(key, "... "), "Invalidating cache... "].join("\n"));

            _this2.invalidateCache();
          }

          return ret;
        },
        set: function set(newValue) {
          if (typeof newValue !== valType) {
            console.warn(["The value trying to be set for key: '".concat(key, "' is '").concat(newValue, "'."), "Expecting type: ".concat(valType), "Invalidating cache..."].join("\n"));

            _this2.invalidateCache();

            if (handlerInitialization) {
              newValue = getStateValue();
            } else {
              var err = new CodedError("Cache Invalidated", "CACHE_INVAL");
              throw err;
            }
          }

          if (typeof localStorage !== "undefined") {
            localStorage.setItem(key, JSON.stringify(newValue));
          }
        }
      };
      handler.set(handler.get());
      handlerInitialization = false;
      this.handlers[key] = handler;
      return handler;
    }
  }], [{
    key: "init",
    value: function init(namespace, version) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var ns = StorageHandler.namespaces[namespace] = StorageHandler.namespaces[namespace] || {};
      var instance = ns[version] = ns[version] || new StorageHandler(namespace, version, options);
      return instance;
    }
  }]);

  return StorageHandler;
}(EventEmitter);

_defineProperty(StorageHandler, "namespaces", {});

export var initStorageNamespace = StorageHandler.init;